export const FeedData = [
  {
    id: "1",
    userName: "friend1",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_user_img1.jpg",
    userAlt: "유저 이미지",
    postImg:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img1.jpg",
    postAlt: "게시물 이미지",
    comment: "여름엔 역시 여행이지!!",
    likeNums: 65,
  },
  {
    id: "2",
    userName: "friend2",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_user_img2.jpg",
    userAlt: "유저 이미지",
    postImg: [
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img2.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img3.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img4.jpg",
    ],
    postAlt: "게시물 이미지",
    comment: "나홀로 여행~ 완전 힐링 제대로!",
    likeNums: 30,
  },
  {
    id: "3",
    userName: "friend3",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_user_img3.jpg",
    userAlt: "유저 이미지",
    postImg: [
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img5.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img6.jpg",
    ],
    postAlt: "게시물 이미지",
    comment: "새로운 캐릭터 나왔는데 같이 게임하실 분~!!",
    likeNums: 23,
  },
  {
    id: "4",
    userName: "friend4",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_user_img4.jpg",
    userAlt: "유저 이미지",
    postImg:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img7.jpg",
    postAlt: "게시물 이미지",
    comment: "카페에서 여유로운 한잔~",
    likeNums: 57,
  },
  {
    id: "5",
    userName: "friend5",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_user_img4.jpg",
    userAlt: "유저 이미지",
    postImg: [
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img8.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img9.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img10.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/03_feed_content_img11.jpg",
    ],
    postAlt: "게시물 이미지",
    comment: "오늘도 뽐내보는 나의 요리실력!",
    likeNums: 83,
  },
];
